import Avatar from '@material-ui/core/Avatar';
import { withRouter } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../core/withGShoc';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../core/style/gstheme';
import { computeComponentIcon } from '../core/utils/utils';
import AccessibleTooltip from '../core/AccessibleTooltip';

const loadOptions = {
    "predicates": [
        "http://purl.org/dc/terms/title",
        "https://grafsync.graphifi.com/schema/gs/activateWorkflow"
    ]
};

class BasicComponentChip extends React.Component {

    render() {

        const { classes, onDelete, isReadOnly, data, viewLang, defaultLang, id, onClick, disabled,
            invalid, compact, highlight, useIfWorkflow, superCompact, dataTest } = this.props;

        // For certain aspects we don't want this chip to be displayed if workflow not activated
        if (useIfWorkflow === true && data.activateWorkflow !== true) return null;

        let label = data.id;
        const displayLang = viewLang && data.title && data.title[viewLang] ? viewLang : defaultLang;
        if (data.title && data.title[displayLang]) {
            label = data.title[displayLang];
        }
        else if (data.title && data.title["und"]) {
            label = data.title["und"];
        }

        // Just in case!
        if (Array.isArray[label]) {
            label = label[0];
        }

        let avatar = computeComponentIcon(data.type, { color: '#ffffff' });

        return (
            <AccessibleTooltip
                interactive={true}
                title={<span style={{ display: 'block', marginTop: 6, marginBottom: 6 }}>{id}</span>}>
                <Chip
                    data-test={dataTest ?
                        invalid ? "invalid-" + dataTest : dataTest
                        :
                        invalid ? "invalid-component-chip" : "component-chip"}
                    color="primary"
                    disabled={disabled}
                    avatar={<Avatar style={{ backgroundColor: '#01579B' }}>{avatar}</Avatar>}
                    style={
                        {
                            ...(invalid) && { backgroundColor: '#CA4F0C' },
                            ...(highlight) && { backgroundColor: '#767676' }
                        }
                    }
                    onClick={onClick}
                    onDelete={!isReadOnly && onDelete ? onDelete : null}
                    label={label}
                    className={superCompact ?
                        classes.noMarginChip
                        :
                        compact ?
                            classes.compactChip
                            :
                            classes.chip}
                />
            </AccessibleTooltip>
        );
    }
}

BasicComponentChip.defaultProps = {
    invalid: false,
    compact: false,
    highlight: false,
    superCompact: false,
    disabled: false,
    useIfWorkflow: undefined
};

BasicComponentChip.propTypes = {
    dataTest: PropTypes.string,
    isReadOnly: PropTypes.bool,
    viewLang: PropTypes.string,
    disabled: PropTypes.bool,
    history: PropTypes.object,
    compact: PropTypes.bool,
    useIfWorkflow: PropTypes.bool,
    highlight: PropTypes.bool,
    classes: PropTypes.object,
    superCompact: PropTypes.bool,
    invalid: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    icon: PropTypes.object,
    onDelete: PropTypes.func,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};

export default withRouter(withStyles(styles)(withGS(BasicComponentChip, ["ALL"], null, loadOptions)));